import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type { TDownloadPartnerBusinessDocumentsZipInternalParams } from "./downloadPartnerBusinessDocumentsZipInternal.schema";

const parseErrorFromBlob = async (blob: Blob): Promise<Error> => {
  const text = await blob.text();
  try {
    const parsed = JSON.parse(text) as { errors?: { message?: string }[] };
    const message = parsed.errors?.[0]?.message;
    if (message != null && message.length > 0) {
      return new Error(message);
    }
  } catch {
    // not JSON
  }
  return new Error(text.length > 0 ? text.slice(0, 500) : "Request failed");
};

export const downloadPartnerBusinessDocumentsZipInternal = (
  axiosInstance: IAxiosInstance
) => {
  return async (
    params: TDownloadPartnerBusinessDocumentsZipInternalParams
  ): Promise<Blob> => {
    const response = await axiosInstance.noRetry.post<Blob>(
      "/private/api/internal-tools/partner-business-documents-folder",
      params,
      {
        responseType: "blob",
        validateStatus: () => true,
      }
    );

    const contentType = response.headers["content-type"] ?? "";
    if (response.status >= 400 || contentType.includes("application/json")) {
      throw await parseErrorFromBlob(response.data);
    }

    return response.data;
  };
};
